import { CohortBuilderModalLegacy } from '@verantos-dev/types-cohorts';

const MODALS_WITH_ERROR_MESSAGE = [
  CohortBuilderModalLegacy.ADD_SIMPLE_EVENT,
  CohortBuilderModalLegacy.EDIT_SIMPLE_EVENT,
  CohortBuilderModalLegacy.ADD_SUBJECT_VARIABLE,
  CohortBuilderModalLegacy.EDIT_SUBJECT_VARIABLE,
  CohortBuilderModalLegacy.ADD_DERIVED_EVENT,
  CohortBuilderModalLegacy.EDIT_DERIVED_EVENT,
];

export const getShouldShowFieldError = (modal?: CohortBuilderModalLegacy): boolean => {
  return !!modal && MODALS_WITH_ERROR_MESSAGE.includes(modal);
};
